










import { Vue, Component } from 'vue-property-decorator';
import { HTTP } from '@/services/http-service';
import { AxiosResponse } from 'axios';
import { Action } from 'vuex-class';
import { AuthModule } from './store/modules/auth';

@Component({})
export default class App extends Vue {
  mounted() {
    AuthModule.loadUser();
  }
}
